'use client'
import { useState } from 'react'

const Search = ({
  setSearchLicense,
  setSearchName,
  setSearchText,
  mini = false,
  className,
  placeholder = 'NOM / LLICÈNCIA'
}) => {
  const [search, setSearch] = useState('')
  return (
    <fieldset>
      <div className={`grid grid-cols-1 lg:flex ${className}`}>
        {!mini && (
          <div className="flex bg-sec-grey-4 p-5 rounded-l-sm border-white border-r-2 lg:border-r-2">
            <p className="block text-[16px] lg:text-[22px] font-alliance-medium text-blue">
              {placeholder}
            </p>
          </div>
        )}
        <div className="flex bg-sec-grey-4 pl-2 pr-5 rounded-r-sm">
          <input
            type="text"
            className="bg-sec-grey-4 border-none focus:ring-0 lg:w-[188px]"
            onChange={(e) => {
              setSearch(e.target.value)
            }}
            placeholder={placeholder}
          />
          <button
            className="flex justify-center items-center opacity-50 hover:opacity-100 transition-opacity ml-auto"
            onClick={() => {
              if (setSearchText) {
                setSearchText(search)
              } else {
                if (Number.isInteger(parseInt(search))) {
                  setSearchLicense(search)
                  setSearchName('')
                } else {
                  setSearchName(search)
                  setSearchLicense('')
                }
              }
            }}
          >
            <img
              src="/assets/icons/lens.svg"
              alt="icon"
              className="bg-sec-grey-4 ml-5 py-[8px] w-6"
            />
          </button>
        </div>
      </div>
    </fieldset>
  )
}

export default Search
